import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const TransmissionSpec = ({ transmissionSpec }: SpecProps<"transmission_spec">) => {
  const { i18n } = useLingui();

  if (!transmissionSpec) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.transmission_spec",
    message: "Gear type description",
    comment: "Field for 'transmission_spec' in ad specification",
  });
  return <FieldValuePair field={field} value={transmissionSpec} />;
};
